import { useLocation } from "react-router-dom"
import { MdOutlineKeyboardArrowRight } from "react-icons/md"
import jwtDecode from "jwt-decode"
import { FaLock } from "react-icons/fa";

function SidebarItem({
  path,
  open,
  title,
  basePath,
  children,
  childrenList,
  hasChildrenVisible,
  // setActiveNav,
  onClick,
  expandChildren
}) {
  const location = useLocation()
  const decodedToken = jwtDecode(localStorage.getItem("token"))

  const itemIsLocked = (title) => {
    if(title == 'Courses' && decodedToken.hascourses == "False") return true;
    if(title == 'Academy' && decodedToken.HasAcademy == "False") return true;
    if(title == 'Seminars' && decodedToken.HasSeminar == "False") return true;
    return false;
  }

  const childItemIsLocked = (item) => {
    if(item.title == 'Library' && decodedToken.haslibrary == "False") return true;
    if(item.title == 'Reading' && decodedToken.HasReadingList == "False") return true;
    if(item.title == 'Submissions' 
      && decodedToken.role === 'Student' 
      && decodedToken.HasPsSubmission === "False" 
      && decodedToken.HasEssaySubmission === "False") return true;
    return false
  }

  return (
    <>
      <div className="flex cursor-pointer rounded-md text-white duration-300">
        <div
          className={`${open ? "gap-5" : ""}
          flex w-full items-center justify-start`}
        >
          <div onClick={onClick}>{children}</div>
          <div className={`flex w-full items-center ${itemIsLocked(title) ? "" : "justify-between"} gap-3`}>
            <span
              className={`${!open ? "hidden" : "block"} 
              ${path === basePath ? (itemIsLocked(title) ? "text-[#CCCCCC]" : "text-[#FFF]") : "text-[#A5A5A5]"}
              origin-left text-16p font-[500] duration-200`}
              onClick={onClick}
            >
              {title}
            </span>
            {itemIsLocked(title) && <FaLock />}
            {childrenList && (
              <MdOutlineKeyboardArrowRight
                size={28}
                className={`${!open ? "hidden" : "block"} 
                ${
                  hasChildrenVisible
                    ? path === basePath
                      ? "rotate-90 text-[#FFF]"
                      : "rotate-90 text-[#A5A5A5]"
                    : "text-[#A5A5A5]"
                }`}
                onClick={expandChildren}
              />
            )}
          </div>
        </div>
      </div>

      <ul
        className={`${open ? "pt-5  pl-10" : ""}
       ${hasChildrenVisible ? "flex flex-col gap-5" : "hidden"}
      font-bold text-[#A5A5A5] `}
      >
        {childrenList?.map((item, index) => (
          (!item.hidden && <li
            key={index}
            onClick={item.onClick}
            className={`${!open ? "hidden" : "block"} 
              ${location.pathname === item.path ? childItemIsLocked(item) ? "text-[#CCCCCC]" : "text-white" : ""}
              mt-1 cursor-pointer font-[400] ${childItemIsLocked(item) ? 'flex items-center' : ''}`}
          > 
            {item.title}
            {childItemIsLocked(item) && <FaLock className="text-white ml-2"/>}
          </li>)
        ))}
      </ul>
    </>
  )
}

export default SidebarItem
